// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__V0CmP","input":"styles_input__2EOmR","flex":"styles_flex__35FRr","delete_text":"styles_delete_text__3F3Rs","btn_wrapper":"styles_btn_wrapper__2Bib1"};